import { render } from "./goldPrice.vue?vue&type=template&id=32078b3c"
import script from "./goldPrice.vue?vue&type=script&lang=js"
export * from "./goldPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__